import assign = require('object-assign');
import { 
    WidgetEditor,
    Widget as WidgetConstant
} from '../constants';
import { Widget } from '../store/models';

import { IWidgetAction, IWidgetEditorAction } from '../interfaces/actions';
import { IWidgetEditorState } from '../interfaces/states';

const initialState = {
    open: false,
    widgetId: null
};

export default function widgets(state: IWidgetEditorState = initialState, action: IWidgetEditorAction): IWidgetEditorState {
    const payload = action.payload;

    switch (action.type) {
        case WidgetConstant.DELETE:
        case WidgetEditor.CLOSE: {
            return assign({}, state, {
                open: false
            });
        }
        case WidgetEditor.OPEN: {
            return assign({}, state, {
                open: true
            });
        }
        case WidgetEditor.EDIT: {
            return assign({}, state, {
                open: payload.open,
                widgetId: payload.widgetId
            });
        }
        case WidgetConstant.ADD: {
            const widgetPayload = (action as IWidgetAction).payload;

            return assign({}, state, {
                open: true,
                widgetId: widgetPayload.widget.id
            });
        }
        default: {
            return state;
        }
    }
};


// WEBPACK FOOTER //
// ./src/reducers/widgetEditor.ts